import { Button, Divider, Flex } from "antd"
import dayjs from "dayjs"
import { ReactComponent as ArrowRight } from "../../../../../assets/images/icon/arrow-right.svg"
import { useNavigate } from "react-router-dom"
import { Fragment, useEffect, useRef, useState } from "react"
import { useMyContext } from "../../../../../entities/context"
import { deepLinkBridgeElseNewTab } from "../../../../../utils"
import { isIOS } from "react-device-detect"
import { useAllImagesLoaded } from "../../../../../utils/checkImgLoaded"

interface IProps {
    reservationList: Array<IGetMyReservationHistoryResponse>
}

const CancelReservation = ({ reservationList }: IProps) => {
    const navigate = useNavigate();
    const containerRef = useRef<HTMLDivElement>(null);
    const [targetMarginTop, setTargetMarginTop] = useState<number>(0);
    const { topHeight, setMyReservationHistoryTabKey } = useMyContext();
    const { onLoad, allLoaded } = useAllImagesLoaded(reservationList.length);

    useEffect(() => {
        setMyReservationHistoryTabKey(3)
    }, [])

    useEffect(() => {
        if (!containerRef.current) return;
        const targetHeight = containerRef.current.offsetHeight + 12 + 90 + (Number(topHeight) ?? 0);
        const targetValue = window.innerHeight > targetHeight ? window.innerHeight - targetHeight - 28 - (isIOS ? 46 : 20) : 16;
        setTargetMarginTop(targetValue < 0 ? 0 : targetValue)
    }, [reservationList, allLoaded])

    return <>
        <div ref={containerRef}>
            {reservationList.length === 0
                ? <div style={{ paddingTop: 'calc(75% + 12px)', textAlign: 'center' }}>
                    <div className="body/b2 secondary/s800">취소한 프로그램이 없습니다.</div>
                    <div style={{ marginTop: 8 }}>
                        <Button className="sub-title/st2 secondary/s600" style={{ border: '1px solid var(--secondarys400)', borderRadius: '4px' }} color="default" variant="outlined" onClick={() => navigate('/explore')}> 프로그램 둘러보기</Button>
                    </div>
                </div>
                : reservationList.map((reservation, idx, arr) =>
                    <Fragment key={idx}>
                        <div
                            style={{ padding: '20px 0', cursor: 'pointer' }}
                            onClick={() => reservation.isProgram ? navigate(`/program/book/detail/${reservation.reservationId}`) : navigate(`/lecture/${reservation.wellnessLectureId}`)}
                        >
                            <Flex gap={16}>
                                <div style={{ width: 80, height: 80 }}>
                                    <img src={reservation.imageUrl} alt="수업사진" width={'100%'} height={'100%'} style={{ borderRadius: 4, objectFit: 'cover' }} onLoad={onLoad} />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <div className="sub-title/st3" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                        {reservation.title}
                                        {!!reservation.guestCount && <span className="caption/c1 secondary/s600" style={{ padding: '2px 6px', border: '1px solid var(--secondarys300)', borderRadius: 4 }}>게스트 {reservation.guestCount}명</span>}
                                    </div>

                                    <div className="body/b1 secondary/s500" style={{ marginTop: 4 }}>
                                        <div>{dayjs(reservation.startDateTime).format('YYYY.MM.DD (dd) HH:mm')}</div>
                                        {(reservation.teacherName != null && reservation.teacherName !== '') ? reservation.teacherName + ' 코치 · ' : ''} {reservation.yogaCenterName} {reservation.room}
                                    </div>
                                    <div style={{ textAlign: 'right', marginTop: 8 }}>
                                        {reservation.reservationType === '환불 완료' ?
                                            <div className="caption/c1 error/e600" style={{ padding: '4px 8px', backgroundColor: 'var(--errore100)', display: 'inline-block', borderRadius: 4 }}>환불 완료</div>
                                            : !reservation.isDisableBooking
                                                ? <Button type="text" className="sub-title/st1 secondary/s600"
                                                    style={{ gap: 0, padding: '0 4px' }}
                                                    onClick={(event) => {
                                                        reservation.isProgram
                                                            ? navigate(`/wellness-program/${reservation.programId}`)
                                                            : navigate(`/lecture/${reservation.wellnessLectureId}`); event.stopPropagation();
                                                    }}>다시 예약 <ArrowRight width={16} height={16} stroke="var(--secondarys400)" />
                                                </Button>
                                                : <div className="caption/c1 secondary/s800" style={{ padding: '4px 8px', backgroundColor: 'var(--secondarys100)', display: 'inline-block', borderRadius: 4 }}>취소 완료</div>}
                                    </div>
                                </div>
                            </Flex>
                        </div>
                        {idx !== arr.length - 1 && <Divider style={{ borderBlockStart: '1px solid var(--secondarys100)', margin: 0 }} />}
                    </Fragment>)}
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: targetMarginTop, paddingBottom: isIOS ? 46 : 20 }}>
            <div className="btn/text-btn secondary/s600" >
                <div>예약 내역이 안보이시나요?</div>
                <div style={{ textDecoration: 'underline', textAlign: 'center' }} onClick={() => deepLinkBridgeElseNewTab('https://pf.kakao.com/_xmWxbYG/chat')}>컨시어지로 문의해주세요.</div>
            </div>
        </div>
    </>
}

export default CancelReservation